import { Box, Stack, Tab, Typography } from "@mui/material";
import { DebugBox, LoadingBox, useGetParams, useLocalStorage, useNavigateWithParams } from "@northpowerdev/np-react-utils";
import { useState } from "react";
import { useEffect } from "react";

import { StyledDataGrid } from "./DlspStyledDataGrid";
import { hikoAlert } from "../../../utils/HikoAlert";
import { plural, safeFormatDate } from "../../../utils/utilityFunctions";
import DlspTaskStatusChip from "../../styled/DlspTaskStatusChip";
import useFetchJson from "../../../data/useFetchJson";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";

const isoDateStringFormatter = (formatterParams) => safeFormatDate(formatterParams.value, 'd MM h:mmaaa')

const gridColumns = [
    { field: 'priorityFieldQA',             headerName: 'Priority QA',          flex: 0 },
    { field: 'icp',                         headerName: 'ICP',                  flex: 1, minWidth: 150 },
    { field: 'stormArea',                   headerName: 'Storm Area',           flex: 1 },
    { field: 'dsubSuburb',                  headerName: 'Suburb',               flex: 1 },
    { field: 'desktopQACommentsSummary',    headerName: 'Desktop QA Comments',  flex: 1, minWidth: 200 },
    { field: 'fieldQAComments',             headerName: 'Field QA Comments',    flex: 1, minWidth: 200 },
    { field: 'desktopQAOwner',              headerName: 'QA Owner',             flex: 1 },
    { field: 'lastUpdatedDate',             headerName: 'Last Updated',         flex: 1, valueFormatter: isoDateStringFormatter },
    { field: 'workType',                    headerName: 'Work Type',            flex: 1, minWidth: 120  },
    { field: 'status',                      headerName: 'Status',               flex: 1 },
]
const initialFilter =[{ field: '', operator: '', value: '' }]

export default function DlspRemedialTaskList() {
    const navigateToTabSection = useNavigateWithParams(`/dlsp/remedial_task_list`)
    const getParams = useGetParams(['tab'])

    const [orderedTaskList, setOrderedTaskList] = useState([])
    const [tabIndex, setTabIndex] = useState('1')
    const [sectionTab, setSectionTab] = useState('Decommissioned')
    const [filterValues, setFilterValues] = useLocalStorage("remedialFilter", false)

    const getTaskListPath = '/bff/decommissioned-lines-service/api/decommissioned-lines/list-all-by-status'
    const fieldQATasksParams = {
        status: 'Remedial',
        pageIdx: 0,
        pageSize: 2000,
    }
    const {
        isLoading: taskListLoading,
        data: taskList,
    } = useFetchJson(getTaskListPath, { params: fieldQATasksParams }, true)

    const navigateToTaskDetails = useNavigateWithParams('/dlsp/task/details')

    useEffect(() => {
        if (!getParams) {
            return
        }
        if (getParams.tab === 'decommissioned') {
            navigateToTab(getParams.tab)
        }
        if (getParams.tab === 'inactive') {
            navigateToTab(getParams.tab)
        }
        console.log("getParams", getParams)
        // eslint-disable-next-line
    }, [getParams])

    useEffect(() => {
        if (!taskList) return

        setOrderedTaskList([...taskList].map((listTask) => {
            const viewTask = {
                priorityFieldQA: listTask.fieldQA?.remedialPriority || listTask.desktopQA?.remedialPriority,
                icp: listTask.icp,
                stormArea: listTask.stormArea,
                dsubSuburb: listTask.dsubSuburb,
                fieldQABy: listTask.fieldQABy,
                decommissionStatus: listTask.decommissionStatus,
                lastUpdatedDate: listTask.remedialDate || listTask?.fieldQADate || listTask?.landownerPermissionDate || listTask?.desktopQADate,//check me later when data is saved
                desktopQACommentsSummary: listTask.desktopQA?.desktopQAComments,
                fieldQAComments: listTask.fieldQA?.fieldQAComments,
                desktopQAOwner: listTask.desktopQAOwner,
                workType: listTask.remedial?.workers,
                status: listTask.status
            }
            return viewTask

        }).filter((viewTask) => {
            //
            // Remove tasks where decommissionStatus is either disconnected or decommissioned
            //
            return viewTask.decommissionStatus === sectionTab
        }).sort((a, b) => {
            return (a.priorityFieldQA || 'zzz').localeCompare(b.priorityFieldQA || 'zzz') 
        })
        )
    }, [taskList, sectionTab])

    const handleRowClick = (params, event, details) => {
        console.log('handleRowClick', { params, event, details })
        if (!params.row.icp) {
            hikoAlert('No icp in that row!')
            return
        }
        let navigateParams = { icp_number: params.row.icp }
        navigateToTaskDetails(navigateParams)
    }

    const handleChange = (event, newValue) => {
        navigateToTab(newValue)        
    }
    const navigateToTab = (newTab) => {
        if (newTab === "1" || newTab === "decommissioned") {
            navigateToTabSection({ tab: 'decommissioned' })
            setSectionTab('Decommissioned')
            setTabIndex("1")
        }
        if (newTab === "2"|| newTab === "inactive") {
            navigateToTabSection({ tab: 'inactive' })
            setSectionTab('Disconnected')
            setTabIndex("2")
        }
    }

    return (
        <Box className="Page">
            <h3>Decommissioned Lines Safety Project</h3>
            <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'left' }}>
                <h2>Remedial Tasks</h2>
                <DlspTaskStatusChip sx={{ pl: 2 }} status="Remedial" />
            </Stack>

            <LoadingBox loading={taskListLoading}>
                <TabContext value={tabIndex} >
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList onChange={handleChange} indicatorColor={'primary'}>
                            <Tab label="Decommissioned" value="1" />
                            <Tab label="Inactive" value="2" />
                        </TabList>
                    </Box>

                    <TabPanel value="1" style={{ padding: 0, paddingTop: 12 }} >
                        <Typography variant="body1">We found {orderedTaskList?.length || 'no'} task{plural(orderedTaskList?.length)}.</Typography>
                        
                        <StyledDataGrid sx={{ my: 2 }} autoHeight rows={orderedTaskList || []}
                            getRowId={(row) => row.icp}
                            columns={gridColumns}
                            onRowClick={handleRowClick}
                            getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'}
                            onFilterModelChange={(newFilterModel) => {
                                // Handle the updated filter model here
                                setFilterValues(newFilterModel.items)
                                console.log("New filter model:", newFilterModel.items);
                                // You can use this data to make backend requests or perform other actions
                              }}
                            initialState={{
                                filter: {
                                  filterModel: {
                                    items: filterValues? filterValues:initialFilter,
                                  },
                                },
                              }}
                        />
                        <DebugBox title="orderedTaskList" stringify>{orderedTaskList.priorityFieldQA}</DebugBox>
                        <DebugBox title="taskList" stringify>{taskList}</DebugBox>
                    </TabPanel>
                    <TabPanel value="2" style={{ padding: 0, paddingTop: 12 }}>
                        <Typography variant="body1">We found {orderedTaskList?.length || 'no'} task{plural(orderedTaskList?.length)}.</Typography>

                        <StyledDataGrid sx={{ my: 2 }} autoHeight rows={orderedTaskList || []}
                            getRowId={(row) => row.icp}
                            columns={gridColumns}
                            onRowClick={handleRowClick}
                            getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'}
                        />
                        <DebugBox title="orderedTaskList" stringify>{orderedTaskList.priorityFieldQA}</DebugBox>
                        <DebugBox title="taskList" stringify>{taskList}</DebugBox>
                    </TabPanel>
                </TabContext>


            </LoadingBox>


        </Box>
    )
}